import React, { useEffect,useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Button,
} from "@mui/material";
import TableCompo from "../CommonTable/TableCompo";
import { getSipTemplateRequest } from "../../redux/Sip/sipSlice";
import { useNavigate } from "react-router-dom";
import { useAppTheme } from "../../theme/useAppTheme";

const AllSipScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { sipTemplatePlans, loading, error} = useSelector(
    (state) => state.sip || {},
  );
  const themeColors = useAppTheme();
  //
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);


  // useEffect(() => {
  //   dispatch(getSipTemplateRequest({ page: 1, limit: 10 }));
  // }, [dispatch]);
  useEffect(() => {
  dispatch(getSipTemplateRequest({ page: page + 1, limit }));
  }, [dispatch, page, limit]);

  //
  const handleTableChange = (type, payload) => {
  if (type === "changePage") {
    setPage(payload.page);
  }
  if (type === "changeRowsPerPage") {
    setLimit(payload.rowsPerPage);
    setPage(0);
  }
  };


  const handleSipRowClick = (sipItem) => {
    if (!sipItem) {
      console.log("sipItem is NULL — cannot navigate");
      return;
    }

    navigate("/SipSummary", {
      state: {
        sipData: sipItem,
        metal: sipItem?.bullion || {},
        grams: sipItem?.minQty || 0,
        amount: sipItem?.minQty || 0,
      },
    });
  };

  const columns = [
    { field: "planName", headerName: "Plan Name", flex: 1.5 },
    { field: "metal", headerName: "Metal", flex: 1 },
    { field: "range", headerName: "Duration Range", flex: 1 },
    { field: "invest", headerName: "Investment Range", flex: 1.2 },
    { field: "offerType", headerName: "Offer Type", flex: 1 },
    { field: "autodebit", headerName: "Auto Debit", flex: 1 },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      render: (value, row) => (
        <Button
          variant="contained"
          sx={{
            background: themeColors.mediumContainer,
            color: themeColors.text,
            border: `1px solid ${themeColors.scaffold}`,
            textTransform: "none",
            fontWeight: 600,
            "&:hover": { background: themeColors.svgColor },
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleSipRowClick(row?.original ?? null);
          }}
        >
          Start
        </Button>
      ),
    },
  ];

  const tableData = Array.isArray(sipTemplatePlans)
    ? sipTemplatePlans
        .filter((item) => item?.enabled === true)
        .map((item, index) => ({
        id: index + 1,
        planName: item?.name || "N/A",
       metal: item?.bullion
  ? `${item?.bullion?.metalName} ${item?.bullion?.karat || ""}K-${item?.bullion?.purity || ""}`
  : "Money",
        range: `${item?.minDuration || 0}-${item?.maxDuration || 0} ${item?.durationType || ""}`,
        invest: `₹${item?.minQty?.toLocaleString("en-IN") || 0} - ₹${item?.maxQty?.toLocaleString("en-IN") || 0}`,
        offerType: item?.offerType || "Normal",
        autodebit: item?.autodebit ? "Yes" : "No",
        action: "start",
        original: item,
      }))
    : [];

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        mt: 8,
      }}
    >
      <Card
        sx={{
          width: "98%",
          maxWidth: "1300px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          borderRadius: 3,
          background: themeColors.scaffoldGradientColors,
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: 700,
              color: themeColors.primary,
              fontFamily: "Aeonik",
            }}
          >
            All SIP List
          </Typography>

          {loading ? (
            <Box sx={{ textAlign: "center", mt: 10 }}>
              <CircularProgress color="primary" />
              <Typography variant="body2" mt={2}>
                Loading SIP Templates...
              </Typography>
            </Box>
          ) : error ? (
            <Typography color="error" textAlign="center" mt={5}>
              {error}
            </Typography>
          ) : (
            <Box
              sx={{
                height: "70vh",
                width: "100%",
                minWidth: 0,
                overflow: "auto",
              }}
            >
              <TableCompo
                title="SIP Template Plans"
                columns={columns}
                data={tableData}
                page={page}
                limit={limit}
                totalCount={tableData.length}
                onTableChange={handleTableChange}
              />

            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default AllSipScreen;
